module.exports = __webpack_public_path__ + "static/img/new.5cceea41.svg";